import { Box, Typography } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ExploreIcon from '@mui/icons-material/Explore';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { BOOKING_SESSION_UPDATED_EVENT } from '../HomePage/HomePage'; 

export default function BottomNavigation() {
  const navigate = useNavigate();
  const location = useLocation();

  const [hasUpSale, setHasUpSale] = useState(true);

  const readHasUpSale = () => {
    return sessionStorage.getItem('hasUpSale') === 'true';
  };

  useEffect(() => {
    setHasUpSale(readHasUpSale());

    const handleUpdate = () => {
      setHasUpSale(readHasUpSale());
    };

    window.addEventListener('storage', handleUpdate);
    window.addEventListener(BOOKING_SESSION_UPDATED_EVENT, handleUpdate);

    return () => {
      window.removeEventListener('storage', handleUpdate);
      window.removeEventListener(BOOKING_SESSION_UPDATED_EVENT, handleUpdate);
    };
  }, []);

  const isActive = (path) => {
    if (path === '/checkin') return location.pathname.startsWith('/checkin');
    if (path === '/rooms') return location.pathname.startsWith('/room-list');
    if (path === '/top-picks') return location.pathname.startsWith('/top-picks');
    return location.pathname === path;
  };

  const navItems = [
    { label: 'Home', icon: HomeIcon, path: '/home' },
    { label: 'Check In', icon: CalendarTodayIcon, path: '/checkin' },
    {
      label: 'Explore',
      icon: ExploreIcon,
      path: '/top-picks',
      disabled: !hasUpSale, 
    },
    { label: 'Room', icon: VpnKeyIcon, path: '/rooms' },
  ];

  const handleNavigation = (path, disabled) => {
    if (disabled) {
      Swal.fire({
        icon: 'info',
        title: 'Upsell not available',
        text: 'Upsell is not available for this booking.',
        timer: 1800,
        showConfirmButton: false,
      });
      return;
    }

    const userBookings = JSON.parse(sessionStorage.getItem('userBookings') || '[]');
    const currentBookingIndex = Number(sessionStorage.getItem('currentBookingIndex')) || 0;
    const currentBooking = userBookings[currentBookingIndex];

    if ((path === '/checkin' || path === '/rooms') && userBookings.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No bookings found!',
        text: 'You need at least one booking to access this section.',
      });
      return;
    }

    if (path === '/checkin' && currentBooking) {
      navigate(`/checkin/${currentBooking.reservationID}`);
      return;
    }

    if (path === '/rooms' && currentBooking) {
      navigate(`/rooms/${currentBooking.reservationID}`);
      return;
    }

    navigate(path);
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        width: '100vw',
        backgroundColor: '#2e7d7b',
        display: 'flex',
        justifyContent: 'space-around',
        alignItems: 'center',
        py: 2,
        px: 2,
        zIndex: 1000,
      }}
    >
      {navItems.map(({ label, icon: IconComponent, path, disabled }) => {
        const active = isActive(path);

        return (
          <Box
            key={label}
            onClick={() => handleNavigation(path, disabled)}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.5,
              color: disabled
                ? 'rgba(255,255,255,0.4)'
                : active
                  ? 'white'
                  : 'rgba(255,255,255,0.7)',
              flex: 1,
              cursor: disabled ? 'not-allowed' : 'pointer',
              transition: 'color 0.3s ease',
            }}
          >
            <IconComponent sx={{ fontSize: 24 }} />
            <Typography
              variant="caption"
              sx={{
                fontSize: '12px',
                fontWeight: active ? 600 : 400,
              }}
            >
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}